// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + (chunkId === 4963 ? "pui-deprecated" : chunkId) + "." + {"3147":"8908ff7dcb644d451010","4963":"c520265660669357e9c1"}[chunkId] + ".css";
};